module.exports = __webpack_public_path__ + "img/jacket-front-update.20799c5c.jpg";